import Dashboard from '../containers/dashboard'
import PocketsManagement from '../containers/pockets-management'

const Pockets = () => {
  return (
    <Dashboard>
      <PocketsManagement />
    </Dashboard>
  )
}

export default Pockets
